<template>
  <v-app id="inspire">
    <v-app-bar
        app
        class="hide-on-print"
        clipped-right
        color="blue darken-3"
        fixed
        dark
    >
      <v-toolbar-title class="ml-0 " style="display: flex; align-items: center;">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
        <img height="50" :src="user.trekking_agency.logo" v-if="user.trekking_agency && user.trekking_agency.logo">
        <img height="50" src="../../public/logo-min.png" v-else>
        <h4 class="hidden-sm-and-down ml-1">{{
            (user.trekking_agency && user.trekking_agency.name) ?
                user.trekking_agency.name : "Trekking Agency Portal"
          }}</h4>
      </v-toolbar-title>

      <v-spacer/>

      <div v-if="showPendingRejected" class="account-status-alert mr-2">
        <v-icon color="white darken-2">mdi mdi-account-alert</v-icon>
        Account {{ trekking_agency.status === 2 ? 'Verification Pending' : 'Rejected' }}
      </div>
      <v-icon class="white--text">mdi-account-circle</v-icon>
      <h4 class="hidden-sm-and-down ml-1">{{ user.name }}</h4>
      <v-menu class="mr-2" bottom left :nudge-bottom="10" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" icon large>
            <v-icon>mdi-settings</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
              :disabled="item.disabled"
              :href="item.href"
              :key="index"
              :target="item.target"
              :to="!item.href ? { name: item.name } : null"
              @click="item.click"
              rel="noopener"
              ripple="ripple"
              v-for="(item,index) in itemSide"
          >
            <v-list-item-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        class="hide-on-print"
        app
        expand-on-hover
        width="300"
    >
      <v-list dense class="pt-0">
        <template v-for="item in items">
          <v-layout :key="item.heading" align-center row v-if="item.heading">
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex class="text-xs-center" xs6>
              <a class="body-2 black--text" href="#!">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
              :append-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
              :key="item.text"
              :prepend-icon="item.icon"
              v-else-if="item.children"
              v-model="item.model"
          >
            <v-list-item slot="activator" style="padding-left: 0px;">
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <template v-for="(child, i) in item.children">
              <v-list-item :key="i" @click="routeTo(child.to)" style="padding-left: 30px;">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
          <template v-else>
            <v-list-item :key="item.text" :to="item.to">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
    <print-dialog/>

    <v-content class="px-5 py-2">
      <transition>
        <router-view/>
      </transition>
    </v-content>

  </v-app>
</template>
<style>
.account-status-alert {
  border: 2px solid #ffffff !important;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.07em;
  text-align: right;
  float: right;
  padding: 5px 10px;
  color: #ffffff !important;
}
</style>
<script>
import {mapActions, mapGetters} from "vuex";
import OAuth from "../oauth";
import {API_URL, VERSION} from "../config/config.js";
import Http from "axios";
import PrintDialog from "../components/dialogs/PrintDialog.vue";

let oAuth = new OAuth();

export default {
  components: {PrintDialog},

  data: () => ({
    itemSide: [],
    profileImage: require("../assets/logo.png"),
    drawer: null,
    items: [
      {
        icon: "dashboard",
        text: "Dashboard",
        to: {name: "Dashboard"}
      },
      {
        icon: "mdi-alpha-t-box",
        text: "Trekking Request",
        to: {name: "TrekkingRequestList"}
      },
      // {
      //   icon: "notes",
      //   text: "Passports",
      //   to: { name: "AddPassports" }
      // },
      {
        icon: "mdi-account-supervisor",
        text: "Guide/Staffs",
        model: false,
        children: [
          {
            icon: "mdi-account",
            text: "Guides",
            to: {name: "AddGuides"}
          },
          {
            icon: "mdi-account",
            text: "Staffs",
            to: {name: "AddStaffs"}
          }
        ]
      },

      // {
      //     icon: "mdi-file-document-box",
      //     text: "Certificates/License",
      //     model: false,
      //     children: [
      //         {
      //             icon: "mdi-cash",
      //             text: "Tax Clearance Certificate",
      //             to: {name: "TaxClearanceCertificate"}
      //         },
      //         {
      //             icon: "mdi-google-analytics",
      //             text: "Nepal Tourism Board Certificate",
      //             to: {name: "NepalTourismCertificate"}
      //         },
      //         {
      //             icon: "mdi-bank",
      //             text: "Nepal Rastra Bank License",
      //             to: {name: "NepalRastraBankLicense"}
      //         },
      //         {
      //             icon: "mdi-factory",
      //             text: "Domestic & Small Industries License",
      //             to: {name: "DomesticSmallIndustriesLicense"}
      //         },
      //         {
      //             icon: "mdi-registered-trademark",
      //             text: "Company Registration Document",
      //             to: {name: "RegisterDocument"}
      //         },
      //         {
      //             icon: "mdi-domain",
      //             text: "Vat/Pan Certificate",
      //             to: {name: "VatPanCertificate"}
      //         }
      //     ]
      // },
      // {
      //     icon: "history",
      //     text: "History",
      //     to: {name: "TrekkingHistory"}
      // },
      {
        icon: "mdi-file-document-box",
        text: "Certificates/License",
        to: {name: "TrekkingDocument"}
      }
    ]
  }),
  computed: {
    ...mapGetters("Notification", ["snackbar"]),
    ...mapGetters("AuthUser", ["user", "trekking_agency"]),
    computeLogo() {
      return require("@/assets/logo.png");
    },
    showPendingRejected() {
      let show_pending_rejected = false;
      if (this.trekking_agency.status) {
        show_pending_rejected = this.trekking_agency.status !== 1;
      }

      return show_pending_rejected;
    }
  },
  mounted() {
    this.fetchCurrentUser();
    this.itemSide = [
      {
        icon: "account_circle",
        href: "#",
        title: "Profile",
        click: () => {
          this.$router.push({name: "Profile"});
        }
      },
      {
        icon: "logout",
        href: "#",
        title: "Logout",
        click: () => {
          this.logoutNow();
        }
      }
    ];
  },
  methods: {
    ...mapActions("AuthUser", ["fetchCurrentUser", "hasPermission",]),
    routeTo(to) {
      this.$router.push(to);
    },
    logoutNow() {
      const self = this;
      Http.post(API_URL + VERSION + "/logout").then(response => {

        oAuth.logout();
        self.$router.go({name: "Login"});
      });
    }
  }
};
</script>
